import { useEffect, useState } from "react";
import axios from "axios";
import { buildApiUrl } from "../api/apiClient";

// The monitoring session stays in memory and never replaces the visitor's login.
const useMonitoringAuth = () => {
  const [auth, setAuth] = useState({ accessToken: null, error: null });

  useEffect(() => {
    const username = process.env.REACT_APP_MONITORING_USERNAME;
    const password = process.env.REACT_APP_MONITORING_PASSWORD;
    if (!username || !password) {
      setAuth({
        accessToken: null,
        error: "Account di monitoraggio non configurato.",
      });
      return;
    }

    let active = true;
    let refreshToken = null;
    let timer;
    let controller;

    const authenticate = async () => {
      controller = new AbortController();
      try {
        const { data } = await axios.post(
          buildApiUrl("/api/auth/token"),
          {
            client_id: process.env.REACT_APP_CLIENT_ID,
            ...(refreshToken
              ? { grant_type: "refresh_token", refresh_token: refreshToken }
              : { grant_type: "password", username, password }),
          },
          { signal: controller.signal, timeout: 15000 },
        );
        if (!data.access_token) throw new Error("Missing monitoring token");
        if (!active) return;
        refreshToken = data.refresh_token || null;
        setAuth({ accessToken: data.access_token, error: null });
        const refreshDelay =
          Math.max(1, Number(data.expires_in || 60) - 30) * 1000;
        timer = setTimeout(authenticate, refreshDelay);
      } catch {
        if (!active) return;
        if (refreshToken) {
          refreshToken = null;
          authenticate();
          return;
        }
        setAuth({
          accessToken: null,
          error: "Accesso al monitoraggio non riuscito. Nuovo tentativo tra 30 secondi.",
        });
        timer = setTimeout(authenticate, 30000);
      }
    };

    authenticate();
    return () => {
      active = false;
      clearTimeout(timer);
      controller?.abort();
    };
  }, []);

  return auth;
};

export default useMonitoringAuth;
